export default `{
  "reject_requests": ["css"]
}`